// extracted by mini-css-extract-plugin
export default {"payment-bill-detail":"payment-bill-detail-440e","two-third-width":"two-third-width-9a0a","clickable-row":"clickable-row-7459"};